import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompanyComponent } from './company/company.component';
import { CompanyAddressComponent } from './company-address/company-address.component';
import { VerificationComponent } from './verification/verification.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import {
  ROUTE_REGISTRATION,
  ROUTE_COMPANY,
  ROUTE_COMPANYADDRESS,
  ROUTE_VERIFICATION,
  ROUTE_CONFIRMATION,
  ROUTE_SUBMISSION,
  ROUTE_REGISTRATION_COMPANY,
  ROUTE_REGISTRATION_COMPANYADDRESS,
  ROUTE_REGISTRATION_SUBMISSION,
  ROUTE_REGISTRATION_CONFIRMATION,
  ROUTE_SIGNIN
} from './shared/routes';
import { RegistrationComponent } from './registration/registration.component';
import { SubmissionComponent } from './submission/submission.component';
import { McDotOperateLocationComponent } from './mc-dot-operate-location/mc-dot-operate-location.component';

const registrationTitle = 'Get Started with FleetOperate';
const registrationSubtext2 = 'Create your FleetOperate account to manage your fleet, driver hours and much more!';
const logoLink = 'assets/img/FleetOperate-white-logo.png';
const backgroundColor = '#1b4686';

export const carrierRegistrationRoutes: Routes = [
  {
    path: '',
    component: McDotOperateLocationComponent,
    data: { forwardRoute: ROUTE_REGISTRATION_COMPANY, step: 1, numSteps: 3 }
  },
  {
    path: ROUTE_COMPANY,
    component: CompanyComponent,
    data: { backRoute: ROUTE_REGISTRATION, forwardRoute: ROUTE_REGISTRATION_COMPANYADDRESS, step: 2, numSteps: 3 }
  },
  {
    path: ROUTE_COMPANYADDRESS,
    component: CompanyAddressComponent,
    data: { backRoute: ROUTE_REGISTRATION_COMPANY, forwardRoute: ROUTE_REGISTRATION_SUBMISSION, step: 3, numSteps: 3 }
  },
  {
    path: ROUTE_SUBMISSION,
    component: SubmissionComponent,
    data: { forwardRoute: ROUTE_SIGNIN, step: 3, numSteps: 3 }
  },
  {
    path: ROUTE_VERIFICATION,
    component: VerificationComponent,
    data: { forwardRoute: ROUTE_REGISTRATION_CONFIRMATION, step: 3, numSteps: 3 }
  },
  {
    path: ROUTE_CONFIRMATION,
    component: ConfirmationComponent,
    data: { forwardRoute: ROUTE_SIGNIN, step: 3, numSteps: 3 }
  }
];

export const routes: Routes = [
  {
    path: ROUTE_REGISTRATION,
    component: RegistrationComponent,
    children: carrierRegistrationRoutes,
    data: { registrationTitle, registrationSubtext2, logoLink, backgroundColor }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedRegistrationFeatureRegistrationCarrierRoutingModule {}

export { ROUTE_REGISTRATION } from './shared/routes';
